// removed by extract-text-webpack-plugin
module.exports = {"container":"Tables-container","wide":"Tables-wide","header":"Tables-header","chart":"Tables-chart","footer":"Tables-footer"};